import React from "react";
import { useSearchParams } from "react-router-dom";
import companyLogo from "../../assets/images/AcrossLogo.png";
import "./index.scss";

const ThankYou = () => {
  const [searchParams] = useSearchParams();
  const entityName = searchParams.get("entityName") || "";
  const entityId = searchParams.get("entityId") || "";
  const alreadySubmitted = searchParams.get("alreadySubmitted") === "true";

  return (
    <div className="thankyou-page">
      <div className="thankyou-card">
        <img src={companyLogo} alt="Across Assist" className="thankyou-logo" />

        <div
          className={`thankyou-icon ${alreadySubmitted ? "thankyou-icon--info" : ""}`}
        >
          {alreadySubmitted ? (
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          ) : (
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          )}
        </div>

        <h1 className="thankyou-title">
          {alreadySubmitted
            ? "Already Submitted"
            : "KYC Submitted Successfully"}
        </h1>

        <p className="thankyou-subtitle">
          {alreadySubmitted
            ? "Your KYC documents have already been submitted. Our team is reviewing your application."
            : "Thank you for completing your KYC onboarding. Your details have been submitted and are under review."}
        </p>

        {(entityName || entityId) && (
          <div className="thankyou-info">
            {entityName && (
              <div className="thankyou-info__row">
                <span className="thankyou-info__row-label">Entity Name</span>
                <span className="thankyou-info__row-value">{entityName}</span>
              </div>
            )}
            {entityId && (
              <div className="thankyou-info__row">
                <span className="thankyou-info__row-label">Entity ID</span>
                <span className="thankyou-info__row-value">{entityId}</span>
              </div>
            )}
          </div>
        )}

        <div className="thankyou-divider" />

        <p className="thankyou-note">
          {alreadySubmitted
            ? "If you believe this is an error or need to make changes, please contact your SPOC."
            : "Our team will review your submission and get in touch with you shortly. If you have any questions, please contact your SPOC."}
        </p>
      </div>
    </div>
  );
};

export default ThankYou;
